import { render, staticRenderFns } from "./McqAnswerSheet.vue?vue&type=template&id=24dd180e&scoped=true"
import script from "./McqAnswerSheet.vue?vue&type=script&lang=js"
export * from "./McqAnswerSheet.vue?vue&type=script&lang=js"
import style0 from "./McqAnswerSheet.vue?vue&type=style&index=0&id=24dd180e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dd180e",
  null
  
)

export default component.exports